import Link from 'next/link'
import { MdChevronRight } from 'react-icons/md'

import { Card } from 'src/components/atoms/Card'
import { ButtonLink } from 'src/components/atoms/Link'
import { Heading4 } from 'src/components/atoms/Typography'

export type GettingStartedGuidesProps = {
  links: Array<{ text: string; href: string }>
  narrow?: boolean
}

export const GettingStartedGuides = ({
  links,
  narrow = false
}: GettingStartedGuidesProps) => {
  return (
    <Card
      className={`flex flex-col gap-5 ${
        narrow ? 'lg:max-w-[380px]' : 'flex-1'
      }`}
    >
      <Heading4 className='font-bold! text-[20px]! leading-[26px]!'>
        Guides to help you get started
      </Heading4>
      <div className='flex flex-col gap-5 '>
        {links.map((link, idx) => (
          <Link key={`getting_started_${idx}`} href={link.href} target='_blank'>
            <div className='group hover:bg-frostWhite items-center flex flex-row px-5 py-[15px] border border-superSilver rounded-[5px]'>
              <span className='flex-1 text-[14px] leading-[20px] md:text-[16px] md:leading-[24px] font-semibold'>
                {link.text}
              </span>
              <MdChevronRight
                size={20}
                className='transition-all group-hover:translate-x-1'
              />
            </div>
          </Link>
        ))}
        <ButtonLink
          variant='text'
          className='self-start no-underline text-[14px] leading-[20px] md:text-[16px] md:leading-[24px] font-medium hover:underline'
          isExternal
          href='https://help.treesthatcount.co.nz/en/'
        >
          View all help articles and guides
        </ButtonLink>
      </div>
    </Card>
  )
}
